import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-joey-navy py-16 px-8 max-md:px-5">
      <div className="max-w-[1200px] mx-auto flex justify-center">
        <div className="w-full">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
            {/* Brand Section */}
            <div className="lg:col-span-1">
              <h3 className="text-subtitle text-joey-cyan max-md:text-lg">Joey</h3>
              <p className="text-body text-gray-300 mb-6 max-md:text-base">
                Keeping families connected and children safe in the digital world.
              </p>
              <div className="flex flex-col gap-2 mt-3 text-body text-gray-300 max-md:text-base">
                <span>Based in Melbourne, Australia</span>
                <a
                  href="mailto:joey@joeyfamily.com"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  joey@joeyfamily.com
                </a>
                <a
                  href="https://www.google.com/maps/place/JoeyFamily.com/@-37.7661356,145.0382284,17z/data=!4m6!3m5!1s0x6ad645b9bad63bcb:0xefaccaef878decd2!8m2!3d-37.7661356!4d145.0382284!16s%2Fg%2F11ymfx6tt_?hl=en-GB&entry=ttu&g_ep=EgoyMDI1MTExMi4wIKXMDSoASAFQAw%3D%3D"
                  className="text-gray-300 hover:text-white transition-colors"
                  target="_blank"
                  rel="noreferrer"
                >
                  View Joey on Google
                </a>
              </div>
              <div className="flex gap-2 text-gray-300 mt-6 max-md:text-base">
                <Link to="/privacy" className="hover:text-white transition-colors">
                  Privacy
                </Link>
                <span>·</span>
                <Link to="/terms" className="hover:text-white transition-colors">
                  Terms
                </Link>
              </div>
            </div>

            {/* Popular Pages Section */}
            <div>
              <h4 className="text-body text-white max-md:text-base">Popular Pages</h4>
              <ul className="space-y-4 mt-6">
                <li>
                  <Link
                    to="/features/smart-alerts"
                    className="text-body text-gray-300 hover:text-white transition-colors max-md:text-base"
                    id="footer_popular_smart_alerts"
                  >
                    Smart Alerts
                  </Link>
                </li>
                <li>
                  <Link
                    to="/pricing"
                    className="text-body text-gray-300 hover:text-white transition-colors max-md:text-base"
                    id="footer_popular_pricing"
                  >
                    Pricing
                  </Link>
                </li>
                <li>
                  <Link
                    to="/articles/5/as-parent-why-i-created-this-app-joey"
                    className="text-body text-gray-300 hover:text-white transition-colors max-md:text-base"
                  >
                    As a parent, why I created this app, Joey
                  </Link>
                </li>
                <li>
                  <Link
                    to="/articles/30/what-is-the-joey-social-graph"
                    className="text-body text-gray-300 hover:text-white transition-colors max-md:text-base"
                  >
                    What is the Joey Social Graph?
                  </Link>
                </li>
              </ul>
            </div>

            {/* Product Section */}
            <div>
              <h4 className="text-body text-white max-md:text-base">Product</h4>
              <ul className="space-y-4 mt-6">
                <li>
                  <Link
                    to="/features/contact-verification"
                    className="text-body text-gray-300 hover:text-white transition-colors max-md:text-base"
                  >
                    Contact Verification
                  </Link>
                </li>
                <li>
                  <Link
                    to="/features/iphone-monitoring"
                    className="text-body text-gray-300 hover:text-white transition-colors max-md:text-base"
                  >
                    iPhone & iMessage Monitoring
                  </Link>
                </li>
                <li>
                  <Link
                    to="/features/hows-my-child-report"
                    className="text-body text-gray-300 hover:text-white transition-colors max-md:text-base"
                  >
                    How's My Child?
                  </Link>
                </li>
                <li>
                  <Link
                    to="/features/smart-alerts"
                    className="text-body text-gray-300 hover:text-white transition-colors max-md:text-base"
                  >
                    Smart Alerts
                  </Link>
                </li>
                <li>
                  <Link
                    to="/features/analytics"
                    className="text-body text-gray-300 hover:text-white transition-colors max-md:text-base"
                  >
                    Analytics &amp; Social Graph
                  </Link>
                </li>
              </ul>
            </div>

            {/* Resources Section */}
            <div>
              <h4 className="text-body text-white max-md:text-base">Resources</h4>
              <ul className="space-y-4 mt-6">
                <li>
                  <Link
                    to="/articles"
                    className="text-body text-gray-300 hover:text-white transition-colors max-md:text-base"
                  >
                    Articles
                  </Link>
                </li>
                <li>
                  <Link
                    to="/faqs"
                    className="text-body text-gray-300 hover:text-white transition-colors max-md:text-base"
                  >
                    FAQ
                  </Link>
                </li>
                <li>
                  <Link
                    to="/security"
                    className="text-body text-gray-300 hover:text-white transition-colors max-md:text-base"
                  >
                    Security &amp; Trust
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about-us"
                    className="text-body text-gray-300 hover:text-white transition-colors max-md:text-base"
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="text-body text-gray-300 hover:text-white transition-colors max-md:text-base"
                  >
                    Contact Support
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Copyright */}
          <div className="border-t border-gray-600 mt-12 pt-8">
            <p className="text-center text-gray-400">
              © 2025 JoeyFamily.com. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
